import { useEffect } from 'react';
import { IS_PROD as isProd } from '../config/api';
import { useLocale } from '../i18n/LocaleContext';
import './DevBanner.scss';

// Thin banner pinned to the top of every page on any non-production build —
// local dev and the dev host both — so nobody mistakes one for the live portal.
// Mirrors the admin panel's banner; see admin/src/components/DevBanner.js.
export default function DevBanner() {
  const { t } = useLocale();

  // Push page content down by the banner height so it never covers the header.
  // Cleaned up if the banner ever unmounts.
  useEffect(() => {
    if (isProd) return undefined;
    document.body.classList.add('has-dev-banner');
    return () => document.body.classList.remove('has-dev-banner');
  }, []);

  if (isProd) return null;

  return (
    <div className="dev-banner">
      <span className="dev-banner-full">{t('dev.bannerFull')}</span>
      <span className="dev-banner-short">{t('dev.bannerShort')}</span>
      {/* _top so the link escapes the Shopify admin iframe the partner
          portal also runs inside; on a normal page it is just this window. */}
      <a href="https://creators.outfino.app" target="_top" rel="noopener">creators.outfino.app</a>
    </div>
  );
}
